import React, { useEffect, useRef, useState } from 'react';

const CircularLoader = () => {
  const [percentage, setPercentage] = useState(0);
  const [visible, setVisible] = useState(true);
  const intervalRef = useRef(null);

  const radius = 20;
  const stroke = 4;
  const normalizedRadius = radius - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setPercentage(prev => {
        if (prev >= 100) {
          clearInterval(intervalRef.current);
          return 100;
        }
        return prev + 1;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, []);

  if (!visible) return null;

  return (
    <div
      // style={{
      //   position: 'fixed',
      //   top: '230px',
      //   right: '16px',
      //   zIndex: 9999,
      //   display: 'flex',
      //   alignItems: 'center',
      //   gap: '10px',
      //   backgroundColor: 'rgba(255, 255, 255, 0.9)',
      //   padding: '8px 12px',
      //   borderRadius: '8px',
      //   boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      // }}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        backgroundColor: 'white',
        padding: '8px 12px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        minWidth: '200px',
        maxWidth: '240px',
        height: '60px',
        pointerEvents: 'auto'
      }}
    >
      <svg height="50" width="50">
        <circle
          stroke="#e6e6e6"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx="25"
          cy="25"
        />
        <circle
          stroke="#4caf50"
          fill="transparent"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          r={normalizedRadius}
          cx="25"
          cy="25"
          style={{ transition: 'stroke-dashoffset 1s linear' }}
        />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dy=".3em"
          fontSize="12"
          fontWeight="bold"
          fill="#333"
        >
          {percentage}%
        </text>
      </svg>
      <span style={{ fontSize: '14px', color: '#333' }}>Processing...</span>
      <button
        onClick={() => setVisible(false)}
        style={{
          background: 'none',
          border: 'none',
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#999',
          cursor: 'pointer',
          marginLeft: 'auto',
        }}
        aria-label="Close"
      >
        ×
      </button>
    </div>
  );
};

export default CircularLoader;